export default {
  rewardList : state => state.rewardList,
  rewardData : state => state.rewardData,

  rewardHistoryList : state => state.rewardHistoryList,
  rewardHistoryData : state => state.rewardHistoryData
}
